<div class="map-view pt-55">
  <div class="map-container">
    <div class="map-frame">
      <div id="map"></div>
    </div>
  </div>
</div>

<div style="display: none;">
  <a *ngFor="let property of properties" [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)"
    id="{{property.reference.toLowerCase()}}" class="propertyLink"></a>
</div>